import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import PageTitle from './PageTitle';
import PromotionBanner from './PromotionBanner';
import { DocumentTextIcon } from '@heroicons/react/24/solid';
import { useTranslations } from '../hooks/useTranslations';


function Layout() {
  const location = useLocation();
  const { t } = useTranslations();
  
  const getPageTitle = () => {
    switch(location.pathname) {
      case '/':
        return t('pages.dashboard');
      case '/education':
        return t('pages.education');
      case '/education/video':
        return t('pages.videoLessons');
      case '/education/books':
        return t('pages.books');
      case '/education/glossary':
        return t('pages.glossary');
      case '/education/other':
        return t('pages.otherMaterials');
      case '/education/excel':
        return t('pages.excel');
      case '/education/lectures':
        return t('pages.lectures');
      case '/education/indicators':
        return t('pages.indicators');
      case '/activate':
        return t('pages.activate');
      case '/calendar':
        return t('pages.calendar');
      case '/trading':
        return t('pages.trading');
      case '/bonuses':
        return t('pages.bonuses');
      case '/settings':
        return t('pages.settings');
      default:
        return t('pages.dashboard');
    }
  };

  const getBreadcrumbs = () => {
    const crumbs = [];
    switch(location.pathname) {
      case '/':
        crumbs.push({ text: t('pages.home'), path: '/' });
        break;
      case '/education':
        crumbs.push({ text: t('pages.home'), path: '/' });
        crumbs.push({ text: t('pages.education'), path: '/education' });
        break;
      case '/education/video':
        crumbs.push({ text: t('pages.home'), path: '/' });
        crumbs.push({ text: t('pages.education'), path: '/education' });
        crumbs.push({ text: t('pages.videoLessons'), path: '/education/video' });
        break;
      case '/education/books':
        crumbs.push({ text: t('pages.home'), path: '/' });
        crumbs.push({ text: t('pages.education'), path: '/education' });
        crumbs.push({ text: t('pages.books'), path: '/education/books' });
        break;
      case '/education/excel':
        crumbs.push({ text: t('pages.home'), path: '/' });
        crumbs.push({ text: t('pages.education'), path: '/education' });
        crumbs.push({ text: t('pages.excel'), path: '/education/excel' });
        break;
      case '/education/glossary':
        crumbs.push({ text: t('pages.home'), path: '/' });
        crumbs.push({ text: t('pages.education'), path: '/education' });
        crumbs.push({ text: t('pages.glossary'), path: '/education/glossary' });
        break;
      case '/education/other':
        crumbs.push({ text: t('pages.home'), path: '/' });
        crumbs.push({ text: t('pages.education'), path: '/education' });
        crumbs.push({ text: t('pages.otherMaterials'), path: '/education/other' });
        break;
      case '/education/lectures':
        crumbs.push({ text: t('pages.home'), path: '/' });
        crumbs.push({ text: t('pages.education'), path: '/education' });
        crumbs.push({ text: t('pages.lectures'), path: '/education/lectures' });
        break;
      case '/education/indicators':
        crumbs.push({ text: t('pages.home'), path: '/' });
        crumbs.push({ text: t('pages.education'), path: '/education' });
        crumbs.push({ text: t('pages.indicators'), path: '/education/indicators' });
        break;
      case '/activate':
        crumbs.push({ text: t('pages.home'), path: '/' });
        crumbs.push({ text: t('pages.activate'), path: '/activate' });
        break;
      case '/calendar':
        crumbs.push({ text: t('pages.home'), path: '/' });
        crumbs.push({ text: t('pages.calendar'), path: '/calendar' });
        break;
      case '/trading':
        crumbs.push({ text: t('pages.home'), path: '/' });
        crumbs.push({ text: t('pages.trading'), path: '/trading' });
        break;
      case '/bonuses':
        crumbs.push({ text: t('pages.home'), path: '/' });
        crumbs.push({ text: t('pages.bonuses'), path: '/bonuses' });
        break;
      case '/settings':
        crumbs.push({ text: t('pages.home'), path: '/' });
        crumbs.push({ text: t('pages.settings'), path: '/settings' });
        break;
      default:
        crumbs.push({ text: t('pages.home'), path: '/' });
    }
    return crumbs;
  };

  return (
    <div>
      <PromotionBanner />
      <div className="flex min-h-screen">
    
    <Sidebar />
    <div className="flex-1 flex flex-col">
    
      <div className="p-5 md:p-4">
        <div className="flex justify-between items-center mb-4">
          <PageTitle title={getPageTitle()} breadcrumbs={getBreadcrumbs()} />
        
        </div>
        <Outlet />
      </div>
    </div>
  </div>
    </div>

  );
}

export default Layout; 